const convert = {
  true: true,
  false: false,
};

const convertToBool = (value: boolean | "true" | "false" | null): boolean => {
  if (!value) return false;
  if (typeof value === "boolean") return value;
  return convert[value];
};

export default convertToBool;
